window.addEventListener("DOMContentLoaded", () => {
  // function
  function hideReport() {
    let elem_report =
      document.querySelectorAll(".spr-review-reportreview") || false;
    if (elem_report) {
      Array.from(elem_report).map((val) => {
        //val.innerHTML ='<span style="color:#aaa;">報告する</span>';
        val.style.display = "none";
      });
    }
  }

  // Mutation
  let mutateAction = new MutationObserver(() => {
    let reviewParent = document.querySelector("#shopify-product-reviews");
    reviewParent.style.opacity = 1;

    /* 
    
      //// レビューがある時とない時の処理分ける //// 
    
    */
    let getCount = document.querySelector(".spr-summary-starrating") || false;
    let reviewFormParent = document.querySelector(".new-review-form");

    //購入者の有無で分ける部分　ー 共通
    let reviewButton =
      reviewFormParent.querySelector(".spr-form-title") || false;
    let hideButton = document.querySelector(".hiddenButton") || false;
    if (hideButton) {
      reviewButton.innerHTML = hideButton.innerHTML;


      let heightTarget = document.querySelector(".new-review-form");

      // reviewButtonが親
      let writeButton = reviewButton.querySelector(".spr-form-titleBT");
      let writeCloseButton = reviewButton.querySelector(".reviewCloseButton");
      let iconSvg = reviewButton.querySelector(".spr-form-titleBT svg");


      writeButton.addEventListener("click", () => {
        iconSvg.style.transform = "rotate(90deg)";
        heightTarget.style.height = "100%"; // ここ要検討
        writeCloseButton.style.display = "inline-block";
        writeCloseButton.addEventListener("click", () => {
          heightTarget.style.height = "50px";
          writeCloseButton.style.display = "none";
          iconSvg.style.transform = "rotate(0deg)";
        });
      });




      //////////////////

    } else {
      reviewButton.innerHTML = '<p style="margin:0;padding:0;">　</p>';
      reviewFormParent.style.display = "none";
    }

    if (getCount) {
      let elemReviewPoint =
        document.querySelector(".spr-reviewCount").outerHTML;
      getCount.insertAdjacentHTML("afterend", elemReviewPoint);

      let reviewUser = document.querySelectorAll(".spr-review-header-byline");

      // 非表示にするもの
      let elem_write = document.querySelector(".spr-summary-actions-newreview");
      elem_write.style.display = "none";

      // 非表示にするもの -購入者は表示する
      let elem_form = document.querySelector(".spr-form");
      elem_form.style.display = "block";

      //レポート消し
      hideReport();
    } else {
      // レビューがない時の処理
      let elemEmpty = document.querySelector(".spr-summary.rte");
      elemEmpty.innerHTML = document.querySelector(
        ".hiddenReviewNoValue"
      ).innerHTML;
    }

    /* 
    
      //// 以下共通 //// 
    
    */
    //タイトルのすり替え
    let elem_title = document.querySelector(".spr-header-title");
    let hiddenTitle = document.querySelector(".hiddenReviewTitle").innerText;

    elem_title.innerHTML = `<span style="color:#333;font-size:2.4rem;font-weight:400;">${hiddenTitle}</span>`;

    /* 
    
      ========================================
        レビューフォームの書き換え
      ============
    
    */
    let targetArr = [
      ".spr-form-contact-name .spr-form-label",
      ".spr-form-review-rating .spr-form-label",
      ".spr-form-review-title .spr-form-label",
      ".spr-form-review-body .spr-form-label",
    ];
    let targetString = ["ニックネーム", "点数", "タイトル", "内容"];

    targetArr.map((val, key) => {
      reviewFormParent.querySelector(val).innerHTML = targetString[key];
    });
    reviewFormParent.querySelector(".spr-form-input-textarea").placeholder =
      "本文を記入してください";

    /* 
    
      ============
        レビューフォームの書き換え
      ========================================
    
    */
  });

  /* 
    
      Mutationの追加 - レビューの切り替え時に一度再読み込みが走るため
    
    */
  let mutateActionRe = new MutationObserver(() => {
    //レポート消し
    hideReport();
  });

  let config = {
    childList: true,
    attributes: false,
    characterData: false,
  };

  let configRe = {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true,
  };

  let target = document.querySelector("#shopify-product-reviews") || false;

  if (target) {
    mutateAction.observe(target, config);
    mutateActionRe.observe(target, configRe);
  }
});
